let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eJqf4")).then(() => parcelRequire('3iC8w'));